import Column from '@components/Column';
import Indicator from '@components/Indicator';
import useScrollIndicator from '@hooks/ui/useScrollIndicator';

import AllButton from './AllButton';
import useRecentOrders from './hooks/useRecentOrders';
import RecentOrder from './RecentOrder';
import styles from './styles.module.scss';

function RecentOrders() {
    const { onScroll, current } = useScrollIndicator({ totalCount: 6, padding: 20 });
    const orders = useRecentOrders();
    return (
        <Column align='center'>
            <div className={styles.container}
                onScroll={onScroll} >
                {orders?.map((order) => (
                    <RecentOrder recentOrder={order}
                        key={order.orderId}/>
                ))}
                <AllButton/>
            </div>
            <Indicator total={6} current={current} />
        </Column>
    );
}

export default RecentOrders;
